import './App.css';
import Phones from "./pages/Phones";
import Navbar from "./components/Navbar";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import PhoneInfoPage from "./pages/Details";
import Landing from "./pages/Landing";
import ComparisonPage from "./pages/Comparison";

export default function App() {
    return (
        <Router>
            <Navbar/>
            <Routes>
                <Route path="/" element={<Landing/>}/>
                <Route path="/compare" element={<ComparisonPage/>}/>
                <Route path="/phones" element={<Phones/>}/>
                <Route path="/phones/:phoneId" element={<PhoneInfoPage/>}/>
            </Routes>
        </Router>
    );
}

